module.exports = "<ion-view\r\n  title=\"{{::('assets.home.header.label' | translate)}}\"\r\n  hide-nav-bar=\"true\"\r\n>\r\n  <react-component\r\n    class=\"ProjectLayout\"\r\n    name=\"AssetViewOverview\"\r\n    props=\"assetHome.viewProps\"\r\n    watch-depth=\"reference\">\r\n  </react-component>\r\n</ion-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/assets/controllers/assets-home.html
// module id = 3084
// module chunks = 0